module.exports = __webpack_public_path__ + "img/DSC_0026.a836cd19.jpg";